import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './to-do-item.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ToDoItemDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const toDoItemEntity = useAppSelector(state => state.toDoItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="toDoItemDetailsHeading">ToDoItem</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{toDoItemEntity.id}</dd>
          <dt>
            <span id="title">Title</span>
          </dt>
          <dd>{toDoItemEntity.title}</dd>
          <dt>
            <span id="description">Description</span>
          </dt>
          <dd>{toDoItemEntity.description}</dd>
          <dt>User</dt>
          <dd>{toDoItemEntity.user ? toDoItemEntity.user.login : ''}</dd>
          <dt>Folder</dt>
          <dd>{toDoItemEntity.folder ? toDoItemEntity.folder.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/to-do-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/to-do-item/${toDoItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default ToDoItemDetail;
